import { UnderlyingTag } from 'components/underlying-tag';
import { useUnderlyingContext } from 'hooks/useUnderlyingContext';
import type { RateUnderlying } from 'models/underlying/rate';
import { FC } from 'react';

import { ActionCell, NameCell } from '../../Common/Cells';
import { Row } from '../../Common/Row';
import { Table } from '../../Common/Table';

export interface RateTableProps {
  underlyings: RateUnderlying[];
}

export const RateTable: FC<RateTableProps> = ({ underlyings }) => {
  const { canBeRemoved, isReadOnly } = useUnderlyingContext();

  return (
    <Table>
      <thead>
        <tr>
          <NameCell.Header></NameCell.Header>
          {canBeRemoved && !isReadOnly && <ActionCell.Header />}
        </tr>
      </thead>
      <tbody>
        {underlyings.map(underlying => (
          <Row key={underlying.id}>
            <NameCell.Data underlying={underlying} shouldDisplayCode>
              <UnderlyingTag value={underlying} label={underlying.name} size="lg" isReadOnly />
            </NameCell.Data>

            {canBeRemoved && <ActionCell.Remove underlyingId={underlying.id} />}
          </Row>
        ))}
      </tbody>
    </Table>
  );
};

RateTable.displayName = 'RateTable';
